import React, {useEffect, useState} from 'react';
import PhoneNumber from "libphonenumber-js";

function AdminForm({payload, setPayload, handleNext}) {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [errors, setErrors] = useState({
        phoneNumber: ""
    });

    const isVisited = payload.MerchantEnrollmentEmployee?.AdminPhoneNumber;
    useEffect(() => {
        if (isVisited){
            setPhoneNumber(payload.MerchantEnrollmentEmployee.AdminPhoneNumber);
        }
    } ,[]);

    const handleChange = (event) => {
        const {value} = event.target;
        setPhoneNumber(value);
        setErrors({phoneNumber: ""});
    };

    const validate = () => {
        let temp = {...errors};
        temp.phoneNumber = phoneNumber ? "" : "Phone number is required.";
        if (phoneNumber){
            const parsedPhoneNumber = PhoneNumber(phoneNumber, "LB");
            temp.phoneNumber = parsedPhoneNumber.isValid() ? temp.phoneNumber : "Phone number is invalid.";
        }

        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    }

    const handleContinue = () => {
        if (validate()){
            setPayload({...payload, MerchantEnrollmentEmployee: {AdminPhoneNumber: phoneNumber}});
            handleNext();
        }
    }

    //the number input should not be scrollable but can be typed
    // this function should be called on the onWheel event
    const handleScroll = (event) => {
        event.preventDefault();
    }

    //the onWheel event handling
    useEffect(() => {
        const input = document.querySelector("input[type=number]");
        input.addEventListener("wheel", handleScroll);
        return () => {
            input.removeEventListener("wheel", handleScroll);
        }
    }, []);


    return (
        <>
            <div className="form-container payment-information">
                <div className="form-title">
                    ADMIN
                </div>

                <div className="form-group">
                    <div className="form-label">Phone Number</div>
                    <input type="number" className="form-input" placeholder="961" onChange={handleChange} value={phoneNumber}/>
                    {errors.phoneNumber && <div className="error">{errors.phoneNumber}</div>}
                </div>
            </div>
            <button onClick={handleContinue} className="continue-btn">Continue</button>
        </>
    );
}

export default AdminForm;